import React from 'react';
import { View, StyleSheet } from 'react-native';
import SkeletonBlock from '../../../NavigatorReports/components/SkeletonBlock';

interface ConfigSkeletonProps {
  /** Table-shaped skeleton (header + rows) instead of the short form skeleton. */
  table?: boolean;
}

/**
 * Loading placeholder for a configuration card, built from the shared SkeletonBlock.
 * Mirrors the mockup's .cfg-skel stack: a 40% line, then 36px rows (or 60% line), 12px apart.
 */
const ConfigSkeleton: React.FC<ConfigSkeletonProps> = ({ table }) => (
  <View style={styles.stack} accessibilityLabel="Loading">
    <SkeletonBlock style={styles.header} />
    {(table ? [0, 1, 2, 3] : [0]).map((i) => (
      <SkeletonBlock key={i} style={table ? styles.row : styles.field} />
    ))}
    {table ? null : <SkeletonBlock style={styles.line} />}
  </View>
);

const styles = StyleSheet.create({
  stack: { gap: 12 },
  header: { height: 14, width: '40%', borderRadius: 6 },
  row: { height: 36, width: '100%', borderRadius: 6 },
  field: { height: 36, width: '100%', borderRadius: 6 },
  line: { height: 14, width: '60%', borderRadius: 6 },
});

export default ConfigSkeleton;
